/**
 * @p5doc module
 * @name interaction/ajax-form
 *
 * @description
 * # MODULE_TITLE
 *
 * MODULE_DESCRIPTION.
 */

import ApiDecodeExampleHandler from "../handlers/api-decode-example";
import BonzFormHandler from "../handlers/bonz-form";
import PurchaseFormHandler from "../handlers/purchase-form";

const $document = $(document); // TODO: create utils/dom and put $window and $document.

// FIXME: Is this DOM ready needed???.
export default function initAjaxForm(){
  $(document).ready(function() {
    const noop = () => {};
    $document.on("submit.vdAjaxForm", "[data-ajax-form]", function(e) {
      e.preventDefault();

      const $form = $(this);
      const {handler} = $form.data("ajax-form") || {};
      const method = $form.attr("method");
      let url = $form.attr("action");

      const formData = {};

      if ($form.data("recaptcha-action") !== undefined && $form.find("[name=recaptcha_token]").length === 0) {
        console.info("Waiting for reCaptcha response.");
        return;
      }

      $form.find("[name], [data-ajax-form-input]").each(function() {
        const $el = $(this);

        if (url.indexOf(":" + $el.attr("name") + ":") !== -1) {
          url = url.replace(":" + $el.attr("name") + ":", $el.val());
          return;
        }

        switch ($el.attr("type")) {
          case "checkbox":
            formData[$el.attr("name")] = $el.prop("checked") ? $el.val() : null;
            break;
          case "radio":
            if ($el.prop("checked")) {
              formData[$el.attr("name")] = $el.val();
            }
            break;
          default:
            formData[$el.attr("name")] = $el.val();
        }
      });

      switch (handler){
        case "handlers/api-decode-example":
          doAjax(new ApiDecodeExampleHandler($form));
          break;
        case "handlers/bonz-form":
          doAjax(new BonzFormHandler($form));
          break;
        case "handlers/purchase-form":
          doAjax(new PurchaseFormHandler($form));
          break;
        default:
          doAjax({done: noop, fail: noop, always: noop});
          break;
      }

      function doAjax(handler) {
        return $
            .ajax({
              method,
              url,
              data: formData,
              dataType: "json"
            })
            .done((...args) => handler.done(...args))
            .fail((...args) => handler.fail(...args))
            .always((...args) => handler.always(...args));
      }
    });
  });
}
